import * as React from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem 1.5rem;
`

const Item = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
`

const Logo = styled.img`
  display: block;
  height: 1rem;
  max-width: 3.5rem;
  object-fit: contain;
`

export interface NavigationDropdownLogosProps {
  logos: Array<{
    image: {
      filename: string
    }
    alt: string
  }>
}

export const NavigationDropdownLogos = ({ logos }: NavigationDropdownLogosProps) => {
  return (
    <Wrapper>
      {logos.map((item, i) => (
        <Item key={item.image.filename + '_' + i}>
          <Logo src={item.image.filename} alt={item.alt} />
        </Item>
      ))}
    </Wrapper>
  )
}
